import classes from "./Section1.module.css";

export default function Section1() {
  return (
    <section className={classes.bannerWrapper}>
      {/* Overlay */}
      <div className={classes.bannerOverlay}></div>

      {/* Content */}
      <div className={classes.bannerContent}>
        <h1 className={classes.bannerTitle}>About Us</h1>
        <p className={classes.bannerDescription}>
          Server Stock caters to the information technology requirements of its
          clients.
        </p>
      </div>
    </section>
  );
}
